export const languageFromPath = path => /^\/ar(?:\/|$)/.test(path || "") ? "ar" : "en";
export const stripLanguagePrefix = path => languageFromPath(path) === "ar" ? path.slice(3) || "/" : path || "/";

export function localizedPath(path, language) {
  if (!path?.startsWith("/") || path.startsWith("//")) return path;
  const base = stripLanguagePrefix(path);
  if (/^\/blog(?:\/|$)/.test(base)) return base;
  return language === "ar" ? `/ar${base === "/" ? "/" : base}` : base;
}

export function hasLanguageAlternative(path) {
  const base = stripLanguagePrefix(path).replace(/\/+$/, "") || "/";
  return ["/", "/about-us", "/how-it-works", "/men", "/women", "/kids", "/new", "/cards", "/brand", "/faqs", "/terms", "/privacy-policy", "/cookie-policy", "/contact-us", "/all-categories"].includes(base)
    || /^\/(?:product-details\/[^/]+\/\d+|brands\/[^/]+\/[^/]+|products-list\/[^/]+\/[^/]+(?:\/[^/]+\/[^/]+)?)$/.test(base);
}
